import { useIsLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { useSettingEnableFetchProductReviewCount } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingEnableFetchProductReviewCount";
import { useQuery as useProductReviewCountQuery } from "@faire/web-api--source/endpoints/www/api/product-reviews/product/productToken/count/get-hooks";

const REVIEW_COUNT_STALE_TIME_MS = 1000 * 60 * 5; // 5 minutes
export const useProductLevelReviewCounts = (
  productToken?: string,
  staleTime = REVIEW_COUNT_STALE_TIME_MS
) => {
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const isFetchSettingEnabled = useSettingEnableFetchProductReviewCount();

  const { data } = useProductReviewCountQuery(productToken ?? "", {
    enabled: !!productToken && isFetchSettingEnabled && isLoggedInRetailer,
    staleTime,
  });

  return {
    totalProductReviewCount:
      data?.product_reviews_including_similar_product_count,
    withoutSimilarProductReviewCount:
      data?.product_reviews_without_similar_product_count,
  };
};
